export default {
	products: [],

	init() {
		this.hydrateProducts()
	},

	hydrateProducts() {
		const productsString = localStorage.getItem('district-vision-recently-viewed')
		if (!productsString) return

		this.products = JSON.parse(productsString)
	},

	addProduct(product) {
		if (!product || !product.id) return

		if (this.products.some(p => p.id === product.id)) return

		this.products.push(product)

		if (this.products.length > 4) {
			this.products.shift()
		}

		const productsString = JSON.stringify(this.products)
		localStorage.setItem('district-vision-recently-viewed', productsString)
	},

	get recentProducts() {
		return this.products?.reverse().slice(0, 2)
	},
}
